import React from 'react'
import { CSSTransitionGroup } from 'react-transition-group'

const CombineParentsWrapper = props => {
  const { children } = props

  return (
    <div className="container login-full">
      <div className="row">
        <div className="col-sm-8" style={{ overflow: 'hidden' }}>
          <CSSTransitionGroup
            component="div"
            transitionName={
              props.location?.pathname == '/combine/auth' ? 'h2animate-home' : 'h2animate'
            }
            transitionEnterTimeout={400}
            transitionLeaveTimeout={400}>
            {React.cloneElement(children, { key: props.location?.pathname })}
          </CSSTransitionGroup>
        </div>
        <div className="col-sm-4" style={{ backgroundColor: 'white' }}>
          <img src={`/images/headed2/new/combine/H2-CE-Combine-Main.svg`} />
        </div>
      </div>
    </div>
  )
}

export default CombineParentsWrapper
